import Commons from "oc-commons/Commons";
import { GraphMetadata } from "oc-app/metadata/GraphMetadata";

/**
 * Das RichMetadata dient dazu, die metadata, also das Produktmodell, aufzubereiten.
 */
export class RichMetadata extends GraphMetadata {
  constructor(metadata) {
    super(metadata);
    // Der InspirationEditor muss neue Zeilen im Backend aus dem Frontend erzeugen.
    // Da ist der Graphenbaum nicht hilfreich - daher das hier zwischenspeichern:
    this.flatMetadata = _.cloneDeep(metadata);
  }

  getAllBooths() {
    return APP.metadata.Booths.sort((a, b) => (a.Sorting >= b.Sorting ? 1 : -1));
  }

  getAllExhibitions() {
    return APP.metadata.Exhibitions.sort((a, b) => (a.Sorting >= b.Sorting ? 1 : -1));
  }

  getAllBoothSets() {
    return APP.metadata.BoothSets;
  }

  getInspirationsForBoothsetName(boothsetName) {
    const booths = !!boothsetName
      ? APP.metadata.Inspirations.filter((c) => c.Boothset == boothsetName)
      : [];
    return booths;
  }

  getBoothDBId(name) {
    return APP.metadata.Booths.find((b) => b.Name == name)?.id || -1;
  }

  getBoothByInspiration(inspiration) {
    return APP.metadata.Booths.find((b) => b.Inspiration == inspiration);
  }

  getDefaultExhibition(id = 1) {
    return APP.metadata.Exhibitions.find((exh) => exh.id == id) || APP.metadata.Exhibitions[0];
  }

  getDefaultBooth(id = 1) {
    return APP.metadata.Booths.find((booth) => booth.id == id) || APP.metadata.Booths[0];
  }

  async getJsonFromCfgCode(code) {
    const load = async (code) => {
      return new Promise((resolve) => {
        APP.wkfgBackendApi
          .loadMetadata(`table=Konfiguration&where.Inspiration=true&where.Code=${code}`)
          .then((data) => {
            resolve(_.first(data.Konfiguration));
          });
      });
    };
    const inspiration = await load(code);
    return inspiration;
  }

  getAllLocations() {
    return APP.metadata.Locations.sort((a, b) => (a.Sorting >= b.Sorting ? 1 : -1));
  }

  getFormFields() {
    const getOptions = entry => {
      let lang = I18N.getLanguage();
      if(lang == "zh") lang = "zh-tw";
      return entry.OptionsJSON != null ? entry.OptionsJSON.map(e => e[lang]) : entry.Options?.split(",")
    };

    return APP.metadata.ContactDialog.map((e) => {
      return {
        title: e.Title,
        label: e.Label,
        longtext: e.Longtext,
        type: e.Type,
        required: e.Required,
        min: e.Type == "Number" ? e.min : null,
        max: e.Type == "Number" ? e.max : null,
        sort: e.Sorting,
        options: getOptions(e),//e.Options?.split(","),
        verificationRegEx: e.VerificationRegEx,
        placeholder: e.Placeholder,
        Singlerow: e.Singlerow
      };
    }).sort((a, b) => (a.sort >= b.sort ? 1 : -1));
  }

  getSliderImages() {
    return APP.metadata.SliderImages.filter((i) => !i.Disabled).sort((a, b) =>
      a.Sorting >= b.Sorting ? 1 : -1
    );
  }

  getLogo() {
    return _.first(APP.metadata.Basis.filter((items) => items.Logo)).Logo;
  }
}
